// extracted by mini-css-extract-plugin
module.exports = {"mb_large":"AddCustomer_mb_large__2ycLg"};